import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../../components/Navbar/Navbar';
import InsuranceBanner from '../../components/InsuranceBanner/InsuranceBanner';
import PageTitle from '../../components/pagetitle/PageTitle'
import FaqSection from '../../components/FaqSection/FaqSection.jsx';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo-2.svg'
import HeroFAQ from '../../images/faq/hero-FAQ.jpg'
import './FaqPage.css'


const ProjectPage = () => {
    return (
        <Fragment>
            <Helmet>
                <title>FAQ | Stem Cell Therapy & Regenerative Medicine Questions Answered</title>
                <meta name="description" content="Common questions about stem cell therapy, PRP treatment, cost, recovery time, and regenerative medicine procedures. Expert answers from Dr. Eugene Pereira on treatment safety, effectiveness, and candidacy." />
                <meta name="keywords" content="stem cell therapy FAQ, PRP questions, regenerative medicine cost, treatment recovery time, stem cell safety, treatment candidacy" />
                <meta property="og:title" content="FAQ - Stem Cell & Regenerative Medicine Questions" />
                <meta property="og:description" content="Get answers to common questions about stem cell therapy and regenerative medicine treatments." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://ampedtherapeutics.com/faq" />
                <link rel="canonical" href="https://ampedtherapeutics.com/faq" />
            </Helmet>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <InsuranceBanner />
            <div className="faq-hero-wrapper" style={{
                backgroundImage: `url(${HeroFAQ})`
            }}>
                <PageTitle 
                    pageTitle={'FAQ'} 
                    pagesub={'FAQ'} 
                />
            </div>
            <FaqSection />
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />

        </Fragment>
    )
};
export default ProjectPage;





